import React from 'react';
import { renderContent } from 'utilities/content/content-utilities';
import { PriceTerm } from 'types/Product';
import WeeklyBreakdown from './WeeklyBreakdown';
import { DialogSection, DialogText } from '../../styles/DialogStyles';

interface Props {
  longestWeeklyPriceTermWithInterest: PriceTerm;
  productName: string;
  skuPrice: string;
}

function SpreadCostFurtherContent(props: Props) {
  const { longestWeeklyPriceTermWithInterest, productName, skuPrice } = props;

  return (
    <div data-testid="spread-the-cost-further-content">
      <DialogSection>
        <WeeklyBreakdown
          productName={productName}
          skuPrice={skuPrice}
          weeklyTermPeriod={longestWeeklyPriceTermWithInterest.termPeriod}
          weeklyTermMessage={`(${longestWeeklyPriceTermWithInterest.apr}% annual interest rate total amount payable ${longestWeeklyPriceTermWithInterest.totalSellingPrice})`}
          weeklyPrice={longestWeeklyPriceTermWithInterest.weeklyPaymentAmount}
        />
      </DialogSection>

      <DialogSection>
        <DialogText size="1" tag="p" type="paragraph">
          <strong>104</strong> weeks {renderContent('littlewoods.spreadTheCostFurther.available.on.items.info')}
          <strong> £50.00</strong>
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          <strong>156</strong> weeks {renderContent('littlewoods.spreadTheCostFurther.available.on.items.info')}
          <strong> £99.00</strong>
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          <strong>{renderContent('littlewoods.spreadTheCostFurther.info1.1')}</strong>{' '}
          {renderContent('littlewoods.spreadTheCostFurther.info1.2')}
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          <strong>{renderContent('littlewoods.spreadTheCostFurther.info2')}</strong>
        </DialogText>

        <DialogText size="1" tag="p" type="paragraph">
          {renderContent('littlewoods.spreadTheCostFurther.info3')}
        </DialogText>
      </DialogSection>
    </div>
  );
}

export default SpreadCostFurtherContent;
